import React, { useEffect, useState } from "react";
import BackArrowButton from "../../../../parts/back-arrow-button";
import SettingsNav from "../../../../parts/settings-nav";
import submit from "submit-form";
import { ActiveTabCoachComponent } from "./ActiveTabCoachComponent";
import { InviteNewCoachComponent } from "./InviteNewCoachComponent";
import { getRoleNameById } from "./utils/manage-coaches-utils";
import { PendingTabCoachComponent } from "./PendingTabCoachComponent";
import { SettingsBackHandler } from "../../../coaching-portal/settings/components/SettingsBackHandler";

export const ManageCoaches = ({ locals }) => {
  const { query, organizationRoles, activeUser } = locals;
  const { organizationRoleId = null } = activeUser;
  const [tabState, setTabState] = useState("active-tab"); //state to control the active tab
  //to open the invite modal
  const { organizationInviteCoach = false } = query;
  //get the name of the role of the user
  const roleName = getRoleNameById(organizationRoles, organizationRoleId);
  const isAdminOrOwner = roleName === "Owner" || roleName === "Admin";

  /**
   * Change div's content
   * @param {*} tab
   */
  const handleActiveTab = (tab) => {
    setTabState(tab);
  };

  /**
   * Go to invite coach component
   */
  const handleGoToInviteCoach = () => {
    submit(`/actions/refresh/`, {
      method: "GET",
      body: { organizationInviteCoach: true },
    });
  };

  //if this query exists, then render the invite coach component
  if (locals.query.organizationInviteCoach) {
    return (
      <InviteNewCoachComponent
        locals={locals}
        roleOrganizationName={roleName}
      />
    );
  } else {
    return (
      <main className="settings">
        <SettingsNav classNames="mobile-hidden" />
        <section className="manage-coaches">
          <div>
            <header>
              <h3 className="force-mobile-hidden">Manage Coaches</h3>
              <hgroup className="only-show-mobile">
                <SettingsBackHandler title={"Manage Coaches"} />
                {isAdminOrOwner && (
                  <a
                    role="button"
                    data-button-type="primary"
                    onClick={handleGoToInviteCoach}
                  >
                    <img src="/img/new-icons/add.svg" alt="back" />
                    Invite New Coach
                  </a>
                )}
              </hgroup>

              <nav role="tablist">
                <a
                  id="active-tab"
                  onClick={() => handleActiveTab("active-tab")}
                  aria-current={tabState === "active-tab" ? true : undefined}
                >
                  Active Coach
                </a>
                <a
                  id="pending-tab"
                  onClick={() => handleActiveTab("pending-tab")}
                  aria-current={tabState === "pending-tab" ? true : undefined}
                >
                  Pending Invites
                </a>
                {isAdminOrOwner && (
                  <a
                    role="button"
                    data-button-type="primary"
                    onClick={handleGoToInviteCoach}
                    className="mobile-hidden"
                  >
                    <img src="/img/new-icons/add.svg" alt="back" />
                    Invite New Coach
                  </a>
                )}
              </nav>
            </header>
            <ul>
              {tabState === "active-tab" ? (
                <ActiveTabCoachComponent
                  locals={locals}
                  isAdminOrOwner={isAdminOrOwner}
                  roleName={roleName}
                />
              ) : (
                <PendingTabCoachComponent
                  locals={locals}
                  isAdminOrOwner={isAdminOrOwner}
                />
              )}
            </ul>
          </div>
          <div>
            <p className="p5">
              There is no extra charge for adding coaches to your Organization.
              See{" "}
              <a
                rel="noopener"
                target="_blank"
                href="https://mystrengthbook.com/pricing"
                className="pricing-organization-anchor"
              >
                pricing
              </a>{" "}
              on our website.
            </p>
          </div>
        </section>
      </main>
    );
  }
};
